import { c as _c } from "react/compiler-runtime";
import { useMemo } from 'react';
import { type FAQPage, type WithContext } from 'schema-dts';
import { buildFaqJsonLd } from '@/app/components/sections/service/service-center/terms/faq-json-ld';
import type { FaqItem } from '@/app/components/sections/service/service-center/terms/types';
import { reactNodeToSchemaHtml } from '@/app/utils/reactNodeToSchemaHtml';
interface ScriptFaqJsonLdProps {
  items: FaqItem[];
  idSuffix?: string;
  canonicalUrl: string;
  heading: string;
}
export const ScriptFaqJsonLd = t0 => {
  const $ = _c(11);
  const {
    items: t1,
    idSuffix: t2,
    canonicalUrl,
    heading
  } = t0;
  let t3;
  if ($[0] !== t1) {
    t3 = t1 === undefined ? [] : t1;
    $[0] = t1;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const items = t3;
  const idSuffix = t2 === undefined ? "terms" : t2;
  let t4;
  if ($[2] !== canonicalUrl || $[3] !== heading || $[4] !== idSuffix || $[5] !== items) {
    t4 = buildFaqJsonLd({
      url: canonicalUrl,
      name: heading,
      idSuffix,
      items: items.map(_temp)
    });
    $[2] = canonicalUrl;
    $[3] = heading;
    $[4] = idSuffix;
    $[5] = items;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const faqJsonLd = t4;
  if (!faqJsonLd) {
    return null;
  }
  let t5;
  if ($[7] !== faqJsonLd) {
    t5 = JSON.stringify(faqJsonLd);
    $[7] = faqJsonLd;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t5) {
    t6 = <script type="application/ld+json" dangerouslySetInnerHTML={{
      __html: t5
    }} />;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  return t6;
};
function _temp(it) {
  return {
    id: it.id,
    title: it.title,
    content: reactNodeToSchemaHtml(it.content)
  };
}